import { render, staticRenderFns } from "./basicInformationpay.vue?vue&type=template&id=5a344a1c&scoped=true&"
import script from "./basicInformationpay.vue?vue&type=script&lang=js&"
export * from "./basicInformationpay.vue?vue&type=script&lang=js&"
import style0 from "./basicInformationpay.vue?vue&type=style&index=0&id=5a344a1c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a344a1c",
  null
  
)

export default component.exports